import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActionResult, apiActions as commonApiActions, apiResourceActionCreator } from '../../common';
import { authTokenSelector } from '../../session';
import { RESOURCES, USER_RESOURCE_ENDPOINT } from './endpoints';
import getProfileConfig from './getProfile';

const actions = createActions({
  USER: {
    API: {
      SET_PROGRESS_GOALS: apiResourceActionCreator('progressGoals')
    },
    SET_PROGRESS_GOALS: (goals) => ({ goals })
  }
})

export const apiAction = (authToken, goals) => commonApiActions.authenticated.post(USER_RESOURCE_ENDPOINT(RESOURCES.Goals), authToken, goals, actions.user.api.setProgressGoals)

export function* setProgressGoals(action) {
  const authToken = yield select(authTokenSelector);

  if (authToken.idToken) {
    yield put(apiAction(authToken, action.payload.goals));

    const result = yield apiActionResult(actions.user.api.setProgressGoals);

    if (result.success) {
      yield put(getProfileConfig.action.user.getProfile());
    }
  }
}

const configuration = {
  name: 'setProgressGoals',
  action: actions,
  sagas: setProgressGoals,
  reducers: {

  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/setProgressGoals.js